import { useContext, useEffect, useState } from 'react'
import { renderTime } from "../../utils/renderTime"
import { ProfileCard } from "../../components/Candidate Portal/ProfileCard"
import { fetchJobs, fetchProfileData } from "../../services/Candidate Portal/CandidateDashboardApi"
import { toggleJobSave, applyJob, fetchApplications } from "../../services/Candidate Portal/jobApplications"
import { IoBookmark, IoBookmarkOutline } from "react-icons/io5";
import { FiMapPin, FiSearch } from "react-icons/fi";
import { HiOutlineBriefcase } from "react-icons/hi2";
import { DataProvider } from '../../store/ContextProvider'
import Loading from '../Loading'
import MetaData from '../../components/MetaData'
import { JobApplyPopup } from '../../layouts/ui/JobApplyPopup'
import { MdOutlineKeyboardDoubleArrowDown } from "react-icons/md";
import { SlGraph } from "react-icons/sl";
import { renderImgUrl } from '../../utils/renderImgUrl'

export default function Dashboard() {

  const { BeURL, isAuth, currentUser, showAlert, setJobId, setStatus, setApply, setSavingJob } = useContext(DataProvider)
  const [jobs, setJobs] = useState(null)
  const [savedIds, setSavedIds] = useState([]);
  const [appliedIds, setAppliedIds] = useState([]);
  const [saveLoader, setSaveLoader] = useState({ id: "", status: false })
  const [applyLoader, setApplyLoader] = useState({ id: "", status: false })
  const [user, setUser] = useState(null)
  const [keyword, setKeyword] = useState("")
  const [location, setLocation] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [recordsPerPage, setRecordsPerPage] = useState(6)
  const [totalItems, setTotalItems] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [activeTerm, setActiveTerm] = useState("");

  const [popup, setPopup] = useState(false)

  // local typed inputs so user can type before submitting
  const [typedKeyword, setTypedKeyword] = useState("")
  const [typedLocation, setTypedLocation] = useState("")

  const jobType = {
    ft: "Full time",
    pt: "Part time",
    contract: "Contract"
  }

  useEffect(() => {
    if (BeURL && currentUser) {

      fetchJobs(BeURL, keyword, location, currentPage, setCurrentPage, recordsPerPage, setRecordsPerPage, setTotalItems, setTotalPages, setJobs, showAlert)
      fetchProfileData(BeURL, currentUser._id, setUser, showAlert)
      if (isAuth) {
        fetchApplications(BeURL, showAlert, setSavedIds, setAppliedIds)
      }
    }
  }, [BeURL, currentUser, isAuth])

  useEffect(() => {
    if (BeURL && typedKeyword === "") {
      setCurrentPage(1)
      setKeyword("")
      fetchJobs(BeURL, "", location, 1, setCurrentPage, recordsPerPage, setRecordsPerPage, setTotalItems, setTotalPages, setJobs, showAlert)
    }
  }, [typedKeyword])

  useEffect(() => {
    if (currentPage > totalItems) {
      setCurrentPage(totalPages)
    }
    else if (currentPage < 1) {
      setCurrentPage(1)
    }
  }, [currentPage, totalPages])

  const renderSmLoader = () => {
    return (
      <div role="status">
        <svg aria-hidden="true" className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
        <span class="sr-only">Loading...</span>
      </div>
    )
  }

  const handleJobSaveToggle = (id, isSaving) => {
    if (isAuth) {
      toggleJobSave(BeURL, showAlert, id, isSaving, "dashboard", setSaveLoader, setSavedIds)
    }
    else {
      setPopup(true)
      setJobId(id)
      setSavingJob(isSaving)
      setApply("dashboard")
      setStatus("save")
    }
  }

  const handleJobApplication = (id) => {
    if (isAuth) {
      applyJob(BeURL, showAlert, id, setApplyLoader, setAppliedIds)
    }
    else {
      setPopup(true)
      setJobId(id)
      setStatus("apply")
    }

  }

  // Search submit handler — use typed values and reset to page 1
  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault()
    const kw = typedKeyword.trim()
    const loc = typedLocation.trim()
    setKeyword(kw)
    setLocation(loc)
    setCurrentPage(1)
    // call immediately with the new values (page 1)
    fetchJobs(BeURL, keyword || kw, location || loc, Math.min(currentPage, totalPages), setCurrentPage, recordsPerPage, setRecordsPerPage, setTotalItems, setTotalPages, setJobs, showAlert)
  }

  // records per page change — reset to page 1 and call backend
  const handleRecordsChange = (e) => {
    const val = parseInt(e.target.value, 10) || 9
    setRecordsPerPage(val)
    setCurrentPage(1)
    // call backend; we pass the setter so backend may override if needed
    fetchJobs(BeURL, keyword, location, 1, setCurrentPage, val, setRecordsPerPage, setTotalItems, setTotalPages, setJobs, showAlert)
  }

  // pagination navigation — call backend for selected page
  const goToPage = (page) => {
    if (!page || page < 1) return
    window.scrollTo({ top: 0, behavior: 'smooth' })
    fetchJobs(BeURL, keyword, location, page, setCurrentPage, recordsPerPage, setRecordsPerPage, setTotalItems, setTotalPages, setJobs, showAlert)
  }

  const handleJobApplyStatus = (id) => {
    return ((applyLoader.id === id && applyLoader.status) || appliedIds.includes(id)) ? true : false
  }

  if (!jobs) {
    return <Loading />
  }

  return (
    <>
      <MetaData title="Browse Latest Jobs in India | CareerConnect AI"
        description="Browse and apply for the latest Mechanical, Electrical, IT, Embedded and Engineering jobs in India. CareerConnect AI is your smart job portal for fast hiring."
        url="https://www.careerconnectai.com/browse-jobs"
        keywords="search jobs, job portal India, browse jobs, engineering jobs, mechanical jobs, electrical jobs, IT jobs, embedded jobs, apply jobs online, CareerConnect AI, MNC Jobs"
      />

      <div className="py-6 px-6">

        {/* Layout: profile card (hidden on small screens) + jobs */}
        <div className="flex flex-col md:flex-row gap-6">
          {/* {profile card} */}
          {isAuth ?
            (<aside className="hidden lg:block w-full h-fit md:w-80 rounded-xl">
              <ProfileCard user={user} />
            </aside>)
            : ("")}

          <main className={`${isAuth ? "flex-1" : "px-1 sm:px-3 md:px-10 lg:px-20 xl:px-32 2xl:px-40"} w-full`}>
            {/* Search + controls */}
            <form
              onSubmit={handleSearchSubmit}
              className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3"
            >
              {
                isAuth ? (
                  <div className="flex flex-wrap w-full md:w-10/12 lg:w-8/12 gap-3 items-center rounded-lg p-3">
                    <input
                      type="search"
                      placeholder="Search by Job or skill"
                      value={typedKeyword}
                      onChange={(e) => setTypedKeyword(e.target.value)}
                      className="flex-grow px-3 py-2 outline-none rounded-lg border border-gray-300"
                    />

                    <button
                      type="submit"
                      className="bg-primary-200 text-white px-5 py-2 flex items-center gap-2 rounded-lg whitespace-nowrap"
                    >
                      <FiSearch /> Search
                    </button>
                  </div>
                )
                  : (
                    <div className="w-full">
                      {/* Hero Section for Non-Authenticated Users */}
                      <div className="relative bg-gradient-to-br from-primary-400 via-primary-300 to-secondary-300 rounded-2xl overflow-hidden shadow-2xl">
                        {/* Background Pattern */}
                        <div className="absolute inset-0 opacity-10">
                          <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
                          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
                        </div>

                        {/* Content */}
                        <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-20 py-12 md:py-16 lg:py-20">
                          {/* Headline */}
                          <div className="text-center mb-8 md:mb-10">
                            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
                              Get placed in top MNC's
                              {/* <span className="block text-white/90 mt-2 text-2xl font-medium">the place to grow your career</span> */}
                            </h1>
                            <p className="text-white/90 text-base sm:text-lg md:text-xl max-w-3xl mx-auto">
                              Unlock high-salary roles in Mechanical, Electrical, IT & Engineering domains across India
                            </p>
                          </div>

                          {/* Search Box */}
                          <div className="max-w-4xl mx-auto">
                            {/* Floating animation wrapper */}
                            <div className="relative animate-float">
                              {/* Glow effect */}
                              <div className="absolute -inset-1 bg-gradient-to-r from-yellow-400 via-pink-400 to-purple-500 rounded-full opacity-30 blur-xl animate-pulse"></div>

                              {/* Main search container */}
                              <div className="relative rounded-full shadow-2xl transform transition-all duration-500 hover:shadow-3xl hover:scale-[1.02]">
                                <div className="flex flex-col sm:flex-row gap-0">
                                  {/* Search Input */}
                                  <div className="flex-grow relative group">
                                    {/* Animated search icon */}
                                    <div className="absolute left-5 top-1/2 -translate-y-1/2 transition-all duration-300 group-focus-within:scale-110 group-focus-within:text-primary-500">
                                      <FiSearch className="text-gray-400 text-xl group-focus-within:text-primary-400 transition-colors duration-300" />
                                    </div>

                                    {/* Input field */}
                                    <input
                                      type="search"
                                      placeholder={isAuth ? "Search by Job or skill" : "Login or Register to search jobs"}
                                      readOnly={!isAuth}
                                      value={typedKeyword}
                                      onChange={(e) => setTypedKeyword(e.target.value)}
                                      className="w-full pl-14 pr-6 py-4 sm:py-5 text-base sm:text-lg outline-none rounded-full sm:rounded-l-full sm:rounded-r-none border-0 focus:ring-4 focus:ring-primary-200/50 transition-all duration-300 placeholder:text-gray-400 text-gray-800 font-medium"
                                    />

                                    {/* Active indicator line */}
                                    <div className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-primary-400 to-secondary-300 rounded-full transition-all duration-300 w-0 group-focus-within:w-full"></div>
                                  </div>

                                  {/* Search Button */}
                                  <button
                                    type="submit"
                                    disabled={!isAuth}
                                    title={isAuth ? 'Search' : 'Login or Register to Search'}
                                    onClick={(e) => {
                                      handleSearchSubmit(e);
                                      // Scroll to job listings after search
                                      setTimeout(() => {
                                        const jobListings = document.querySelector('.job-listings-container');
                                        if (jobListings) {
                                          jobListings.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                        }
                                      }, 300);
                                    }}
                                    className={`${isAuth ? 'cursor-pointer' : 'cursor-not-allowed'} relative overflow-hidden bg-gradient-to-r from-primary-400 via-primary-500 to-secondary-400 hover:from-primary-500 hover:via-primary-600 hover:to-secondary-500 text-white px-8 sm:px-10 py-4 sm:py-5 flex items-center justify-center gap-3 rounded-full sm:rounded-l-none sm:rounded-r-full whitespace-nowrap font-bold text-base sm:text-lg shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:scale-105 active:scale-95 group`}
                                  >
                                    {/* Shimmer effect */}
                                    <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>

                                    {/* Button content */}
                                    <FiSearch className="text-xl sm:text-2xl transition-transform duration-300 group-hover:rotate-90" />
                                    <span className="relative z-10">Search Jobs</span>

                                    {/* Pulse ring on hover */}
                                    <div className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping-slow bg-white/20"></div>
                                  </button>
                                </div>
                              </div>
                            </div>

                            {/* Popular search suggestions */}
                            <div className="mt-6 text-center animate-fade-in">
                              <p className="text-white/80 text-sm mb-3 flex items-center justify-center gap-2"><SlGraph className='text-yellow-500' /> Popular Searches:</p>
                              <div className="flex flex-wrap justify-center gap-3">
                                {['React JS', 'Java', 'Developer', 'Analyst', 'Engineer'].map((term, idx) => (
                                  <button
                                    key={idx}
                                    type="button"
                                    onClick={() => {
                                      setActiveTerm(term);
                                      setTypedKeyword(term);
                                      setKeyword(term);
                                      setCurrentPage(1);
                                      fetchJobs(BeURL, term, location, 1, setCurrentPage, recordsPerPage, setRecordsPerPage, setTotalItems, setTotalPages, setJobs, showAlert);
                                      setTimeout(() => {
                                        const jobListings = document.querySelector('.job-listings-container');
                                        if (jobListings) jobListings.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                      }, 300);
                                    }}
                                    className={`
                                    rounded-2xl px-4 sm:px-5 py-2 sm:py-3 text-xs sm:text-sm font-semibold
                                 transition-all duration-300 hover:scale-105
                                 ${activeTerm === term
                                        ? "bg-white text-black shadow-xl"
                                        : "bg-transparent border border-white/40 text-white shadow-lg hover:bg-white/10"
                                      }
                                        `}
                                  >
                                    {term}
                                  </button>

                                ))}
                                <div className="flex items-center justify-between job-listings-container scroll-mt-6">
                                  {((keyword || location) && !isAuth) && (
                                    <button
                                      onClick={() => {
                                        setTypedKeyword("");
                                        setTypedLocation("");
                                        setActiveTerm("");
                                        setKeyword("");
                                        setLocation("");
                                        setCurrentPage(1);
                                        fetchJobs(BeURL, "", "", 1, setCurrentPage, recordsPerPage, setRecordsPerPage, setTotalItems, setTotalPages, setJobs, showAlert);
                                      }}
                                      className="bg-gray-100 text-red-500 px-4 py-2 rounded-lg text-sm font-medium  duration-300 flex items-center gap-2 border border-red-500"
                                    >
                                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                      </svg>
                                      Clear Search
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Quick Stats (Cards) */}
                          <div className="flex flex-wrap justify-center items-stretch gap-4 mt-8">
                            {/* Card 1 */}
                            <div className="flex-1 min-w-[250px] max-w-[280px] bg-white/15 backdrop-blur-sm border border-white/25 rounded-2xl p-5 text-white shadow-lg hover:shadow-xl transition-all duration-300">
                              <h4 className="text-lg sm:text-xl font-semibold mb-1">Upto 60+ LPA's</h4>
                              <p className="text-white/80 text-sm">High-paying roles</p>
                            </div>

                            {/* Card 2 */}
                            <div className="flex-1 min-w-[250px] max-w-[280px] bg-white/15 backdrop-blur-sm border border-white/25 rounded-2xl p-5 text-white shadow-lg hover:shadow-xl transition-all duration-300">
                              <h4 className="text-lg sm:text-xl font-semibold mb-1">Hiring in MNC's</h4>
                              <p className="text-white/80 text-sm">Trusted partners</p>
                            </div>

                            {/* Card 3 */}
                            <div className="flex-1 min-w-[250px] max-w-[280px] bg-white/15 backdrop-blur-sm border border-white/25 rounded-2xl p-5 text-white shadow-lg hover:shadow-xl transition-all duration-300">
                              <h4 className="text-lg sm:text-xl font-semibold mb-1">Faster Response</h4>
                              <p className="text-white/80 text-sm">Quick updates</p>
                            </div>

                            {/* Card 4 */}
                            <div className="flex-1 min-w-[250px] max-w-[280px] bg-white/15 backdrop-blur-sm border border-white/25 rounded-2xl p-5 text-white shadow-lg hover:shadow-xl transition-all duration-300">
                              <h4 className="text-lg sm:text-xl font-semibold mb-1">Fresh Jobs Daily</h4>
                              <p className="text-white/80 text-sm">New roles everyday</p>
                            </div>
                          </div>

                          {/* CTA Text */}
                          <div className="text-center mt-8 md:mt-10">
                            <p className="text-white text-sm sm:text-base md:text-lg">
                              New here?
                              <a href='/signup' className="ml-2 underline decoration-2 underline-offset-4 hover:text-yellow-200 hover:decoration-primary-200 transition-colors font-semibold">Create your profile</a>
                              &nbsp;and apply to jobs in minutes!
                              <span className="inline-block ml-2 animate-bounce"><MdOutlineKeyboardDoubleArrowDown /></span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
              }
            </form>
            <div className="flex items-center justify-between my-3 job-listings-container scroll-mt-6">
              <h2 className='font-medium text-lg'>Your personalized Job picks ({totalItems || 0})</h2>
              {((keyword || location) && !isAuth) && (
                <button
                  onClick={() => {
                    setTypedKeyword("");
                    setTypedLocation("");
                    setKeyword("");
                    setActiveTerm("");
                    setLocation("");
                    setCurrentPage(1);
                    fetchJobs(BeURL, "", "", 1, setCurrentPage, recordsPerPage, setRecordsPerPage, setTotalItems, setTotalPages, setJobs, showAlert);
                  }}
                  className="bg-gray-100  text-red-500 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 flex items-center gap-2 border border-red-500"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Clear Search
                </button>
              )}
            </div>
            {/* Jobs grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6 min-h-[50vh] w-full">
              {jobs.length === 0 && (
                <div className="col-span-1 sm:col-span-2 lg:col-span-2 xl:col-span-3 flex items-center justify-center py-16 w-full">
                  <div className="w-full bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl shadow-xl p-8 md:p-12 text-center">
                    {/* Icon */}
                    <div className="flex justify-center mb-6">
                      <div className="bg-primary-100 rounded-full p-6">
                        <svg className="w-16 h-16 text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                      </div>
                    </div>

                    {/* Message */}
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
                      No Jobs Found
                    </h3>
                    <p className="text-gray-600 mb-6 text-base md:text-lg">
                      {keyword || location
                        ? "We couldn't find any jobs matching your search criteria."
                        : "No jobs available at the moment."}
                    </p>

                    {/* CTA Message */}
                    {!isAuth && (
                      <div className="bg-gradient-to-r from-primary-400 to-secondary-300 text-white rounded-xl p-6 mb-6">
                        <p className="text-lg md:text-xl font-semibold mb-2">
                          🎯 Don't Miss Out!
                        </p>
                        <p className="text-sm md:text-base opacity-95">
                          New opportunities are posted daily. Register now to get instant notifications when jobs matching your profile are available!
                        </p>
                      </div>
                    )}

                    {isAuth && (
                      <div className="bg-blue-50 border-2 border-blue-200 text-blue-700 rounded-xl p-5 mb-6">
                        <p className="text-sm md:text-base">
                          💼 <span className="font-semibold">Stay tuned!</span> New jobs are being added regularly. Check back soon or adjust your search criteria.
                        </p>
                      </div>
                    )}

                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
                      {(keyword || location) && (
                        <button
                          onClick={() => {
                            setTypedKeyword("");
                            setTypedLocation("");
                            setKeyword("");
                            setLocation("");
                            setCurrentPage(1);
                            fetchJobs(BeURL, "", "", 1, setCurrentPage, recordsPerPage, setRecordsPerPage, setTotalItems, setTotalPages, setJobs, showAlert);
                          }}
                          className="bg-white border-2 border-primary-400 text-primary-400 hover:bg-primary-50 px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-md hover:shadow-lg"
                        >
                          Clear Search & View All Jobs
                        </button>
                      )}

                      {!isAuth && (
                        <button
                          onClick={() => window.location.href = '/signup'}
                          className="bg-gradient-to-r from-primary-400 to-primary-300 hover:from-primary-500 hover:to-primary-400 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-md hover:shadow-xl transform hover:scale-105"
                        >
                          Register Now - It's Free!
                        </button>
                      )}
                    </div>

                    {/* Alternative Suggestions */}
                    <div className="mt-8 pt-6 border-t border-gray-300">
                      <p className="text-sm text-gray-600 mb-3 font-medium">Try these tips:</p>
                      <ul className="text-sm text-gray-600 space-y-2 text-left max-w-md mx-auto">
                        <li className="flex items-start gap-2">
                          <span className="text-primary-400 mt-0.5">•</span>
                          <span>Use different or more general keywords</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="text-primary-400 mt-0.5">•</span>
                          <span>Check your spelling</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span className="text-primary-400 mt-0.5">•</span>
                          <span>Browse jobs in different locations</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
              {jobs.map((job, idx) => (
                <div key={job._id || idx} className="max-w-full p-5 shadow-lg rounded-xl bg-white">
                  {/* <h3 className='text-primary-300 font-medium cursor-pointer text-xl' onClick={() => window.open(`/job/${job._id}`, "_blank")}>
                    {job?.title || ""}
                  </h3> */}

                  <div className='flex items-start gap-2 md:gap-3 mb-2'>
                    <img src={job.clientLogo || renderImgUrl("", "", job?.client || "C C")} alt="Company Logo" className='h-[50px] aspect-square object-contain rounded-full' />
                    <div>
                      <h3 className='text-primary-300 font-medium cursor-pointer text-xl'>
                        <a href={`/jobs/${job?.slug}`}
                          className='hover:underline'>
                          {job?.title || ""}
                        </a>
                      </h3>
                      <h4 className='text-slate-800 font-medium text-sm'>{job?.client || "Top MNC"}</h4>
                    </div>
                  </div>
                  
                  {/* <h4 className='text-slate-800 font-medium text-sm cursor-pointer' onClick={() => window.open(`/employer/${job?.createdBy?._id}`)}>{job?.createdBy?.companyName || ""}</h4> */}

                  {/* <div className='flex gap-3 flex-wrap items-center text-slate-700 my-2 text-sm'> */}
                  <div className='flex items-center gap-2 my-1 text-sm'>
                    <FiMapPin className='text-lg' />
                    <span>{job?.location?.city || ""}</span>
                  </div>
                  <div className='flex items-center gap-2 my-1 text-sm'>
                    <HiOutlineBriefcase className='text-lg' />
                    <div className='flex items-center gap-1'>
                      <span>{job?.experience?.min || ""}</span>
                      <span> - </span>
                      <span>{job?.experience?.max || ""}</span>
                      <span> yrs </span>
                    </div>
                  </div>
                  {/* </div> */}

                  <p className='my-2 text-sm'>{jobType[job?.employmentType] || ""} <span>, {job?.location?.type || ""}</span></p>

                  <div className='my-2 flex flex-wrap items-center text-sm font-medium'>
                    <span>₹ {(job?.salary?.min + ' LPA') || ""}</span>
                    <span> - ₹ {(job?.salary?.max + ' LPA') || ""}</span>
                  </div>

                  <p className='line-clamp-2 my-3 text-sm' dangerouslySetInnerHTML={{ __html: job?.description || "" }}>
                    {/* {job?.description || ""} */}
                  </p>

                  {
                    job.skills?.length > 0 &&
                    <p className='text-sm my-3 line-clamp-1 w-full'>
                      {job.skills.map((skill, i) => {
                        if (i < 6) return <span className='bg-purple-100 text-secondary-300 px-3 rounded-xl mr-2' key={i}>{skill}</span>
                        return null
                      })}
                    </p>
                  }

                  <div className='flex gap-3 items-stretch my-2'>
                    <button className={`${(saveLoader.id === job._id && saveLoader.status) ? "cursor-not-allowed border-blue-400 text-blue-400" : "cursor-pointer border-primary-400 text-primary-400"} text-xl border p-1 px-2 rounded-lg`} onClick={() => handleJobSaveToggle(job._id, (savedIds.includes(job._id) ? false : true))}>
                      {
                        (saveLoader.id === job._id && saveLoader.status) ?
                          renderSmLoader() :
                          (savedIds.includes(job._id) ? <IoBookmark /> : <IoBookmarkOutline />)
                      }
                    </button>
                    {
                      (applyLoader.id === job._id && applyLoader.status) ?
                        "" : ""
                    }
                    <button className={`${handleJobApplyStatus(job._id) ? "cursor-not-allowed bg-blue-200 text-primary-300" : "cursor-pointer bg-primary-200 text-white"} w-full rounded-lg py-2`} onClick={() => handleJobApplication(job._id)} disabled={handleJobApplyStatus(job._id)}>
                      {
                        (applyLoader.id === job._id && applyLoader.status) ?
                          "Applying..." :
                          (appliedIds.includes(job._id) ? "Applied" : "Apply")
                      }
                    </button>
                  </div>

                  <p className='my-2 text-xs text-right'>{renderTime(job.createdAt)}</p>
                </div>
              ))}
            </div>

            {/* Pagination (driven by backend totalPages state) */}
            <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-3">

              <div className="flex items-center justify-center gap-3 flex-1">
                <label className="text-sm">Items per page</label>
                <select value={recordsPerPage} onChange={handleRecordsChange} className="border rounded-lg px-3 py-2">
                  <option value={6}>6</option>
                  <option value={9}>9</option>
                  <option value={12}>12</option>
                  <option value={15}>15</option>
                </select>
              </div>

              <div className="flex items-center justify-center gap-2 flex-1">
                <button
                  onClick={() => goToPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage <= 1}
                  className={`px-3 py-2 rounded-lg border ${currentPage <= 1 ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                >
                  Prev
                </button>

                {currentPage} of {totalPages || 1}

                <button
                  onClick={() => goToPage(Math.min(totalPages || 1, currentPage + 1))}
                  disabled={currentPage >= (totalPages || 1)}
                  className={`px-3 py-2 rounded-lg border ${currentPage >= (totalPages || 1) ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                >
                  Next
                </button>
              </div>

              <div className="text-sm text-slate-600 flex-1 text-center">
                Total {totalItems || 0} result{totalItems <= 1 ? "" : "s"}
              </div>

            </div>
          </main>
        </div>
        {popup && (
          <JobApplyPopup setPopup={setPopup} />
        )}
      </div >
    </>
  )
}







